module.exports = __webpack_public_path__ + "img/Paomedia-Small-N-Flat-Pin.512.7c4d9252.png";